<template>
  <div class="wrapper indexBg">
    <img src="./../../assets/1-01.png" class="pos_abs" style="width:70vw;left:15vw;top:11vw;" alt="">
    <!-- <img src="./../../assets/btnHDGZ.png" @click="rulesBoxShow=true" class="pos_abs" style="width:22.3vw;left:89.7vw;bottom:18vw;" alt=""> -->
    <img src="./../../assets/btnLOGO.png" class="pos_abs" style="width:72.4vw;left:13.6vw;bottom:5vw;" alt="">
    <div class="btnStart pos_abs" @click="btnStart" v-if="!loginBlooen"></div>
    <div class="pos_abs" style="left:15vw;top:136vw;color:#fff;text-align:center;width:70vw;font-size:12px;">
      <input type="checkbox" id="checkbox" v-model="checked"><label for="checkbox">我已阅读并同意</label><span style="text-decoration:underline;" @click="rulesBoxShow=true">竞猜活动规则</span>
    </div>
    <div style="width:40vw;left:30vw;top:124.4vw;text-align:center;background:#FFDD29;color:#FF3366;border-radius:1vw;line-height:2em;" class="pos_abs" v-if="loginBlooen" @click="myLogin">登录</div>
    <div class="rulesBox" v-if="rulesBoxShow">
      <img src="./../../assets/hdgz.jpg" width="100%" style="margin-bottom:10vw;" alt="">

      <img src="./../../assets/back2.png" class="back" style="width:28vw;left:36vw;bottom:5vw;position:fixed;" @click="rulesBoxShow=false">
    </div>
  </div>
</template>
<script>
import { Toast, Dialog } from "vant";
import { configWXshare, isWechat, cbgcAnalyze } from "@/common/util";
import {
  cgxwClientLogin,
  getToken,
  setToken,
  setMyToken,
  getMyToken,
} from "./../common";
import { authLogin } from "@/apis/olympic";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    Toast,
  },
  data() {
    return {
      rulesBoxShow: false,
      checked: false,
      loginBlooen: false,
    };
  },
  created() {
    document.title = "奥运赛事猜猜猜";

    if (COVERAPP.Attribute.isApp()) {
      let userFromCache = getToken();
      if (!userFromCache) {
        this.loginBlooen = true;
      }
    } else {
      Dialog.alert({
        title: "提示",
        message: "请在川观新闻App客户端参加活动",
      });
    }
    if (!getMyToken("olympicHDGZ")) {
      setMyToken("olympicHDGZ", 1);
    }
    if (getMyToken("olympicHDGZ") == 2) {
      this.checked = true;
    }
  },
  mounted() {
    this.share();
  },
  methods: {
    share: function () {
      //微信分享
      if (isWechat()) {
        this.isWeixin = true;
        // configWXshare({
        //   share_title: "党史知识答题",
        //   share_desc: "四川挑战赛",
        //   share_link: "https://cbgc.scol.com.cn/news/924064",
        //   share_pic:
        //     "https://wximg.chuanbaoguancha.cn/FsEUAP3PaquPg8xlZzx63xZb9aPF",
        // });
      } else {
        try {
          // COVERAPP.Method.Share({
          //   "title": "党史知识答题",
          //   "desc": "四川挑战赛",
          //   "link": "http://marketing.chuanbaoguancha.cn/h5/#/qav2",
          //   "imgUrl": "https://wximg.chuanbaoguancha.cn/FsEUAP3PaquPg8xlZzx63xZb9aPF",
          //   "type": "link",
          //   "origin": "None",
          //   "callback": function (data) {
          //     this.getChanceShare();
          //   },
          // });
          cbgcAnalyze({
            activeId: "olympic",
            activeName: "奥运赛事猜猜猜",
          });
        } catch (e) {}
      }
    },

    //登录
    myLogin: function () {
      cgxwClientLogin(process.env.NODE_ENV == "development").then((ret) => {
        console.log(ret);

        if (ret.user_id) {
          authLogin(ret).then(() => {
            this.loginBlooen = false;
          });
        }
      });
    },
    btnStart: function () {
      if (this.checked) {
        if (getMyToken("olympicHDGZ") == 1) {
          this.rulesBoxShow = true;
          setMyToken("olympicHDGZ", 2);
          this.checked = true;
        } else {
          this.$router.replace({
            name: "timeLine",
          });
        }
      } else {
        Toast.fail(`请认真阅读活动规则并勾选同意`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../common.scss";

.indexBg {
  background: #5aca4a url(./../../assets/1.jpg) no-repeat center top;
  background-size: 100% auto;
}
.btnStart {
  width: 37vw;
  height: 10vw;
  background: url(./../../assets/btnSTART.png) no-repeat center top;
  background-size: 100% 100%;
  left: 31.5vw;
  top: 124.4vw;
}
.rulesBox {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  background: #57cb4a;
  color: #fff;
  overflow-y: scroll;
}
</style>